export default "__VITE_ASSET__CnqTI9Gg__"